import { useEffect } from "react";
import { LoginStep } from "../../../appointment/components/LoginStep/LoginStep";

interface IGroupClassLoginStepProps {
  wizardState: any;
  onLoginSuccess: (user: any) => void;
}

/**
 * Wrapper around LoginStep that saves wizard state to localStorage
 * before showing the login form. This enables state restoration after
 * OAuth or email authentication completes.
 */
export const GroupClassLoginStep = ({
  wizardState,
  onLoginSuccess,
}: IGroupClassLoginStepProps) => {

  // Save wizard state to localStorage when login step is shown
  useEffect(() => {
    if (wizardState) {
      const backupWithTimestamp = {
        ...wizardState,
        timestamp: Date.now(),
      };

      localStorage.setItem(
        "groupClassWizardStateBackup",
        JSON.stringify(backupWithTimestamp)
      );
    }
  }, [wizardState]);

  return (
    <LoginStep
      onLoginSuccess={onLoginSuccess}
      wizardState={wizardState}
    />
  );
};
